var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    section: true,
    'section-video': true,
    [`section${_vm.orderNo}`]: true
  }},[_c('a',{staticClass:"navigation-target",attrs:{"id":_vm.hash,"href":"javascript:void(0);"}}),_vm._v(" "),_c('div',{staticClass:"top-title"},[_c('AtomsCommonAtomTitle',{attrs:{"title":_vm.data.title,"subtitle":_vm.data.subtitle}})],1),_vm._v(" "),(_vm.data.video.video)?_c('div',{staticClass:"video-top"},[_c('AtomsCommonSliderAtomVideoSlider',{attrs:{"slider-video":_vm.data.video}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }